import * as React from 'react'

import getConfig from 'next/config'

import { RouteConfigs } from '@grandvisionhq/frk-routing'
import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/frames'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { getDeliveryIndicatorConfig, getSpecifications } from '../../../configuration'

const { publicRuntimeConfig } = getConfig()
const defaultAppointmentTypeId = publicRuntimeConfig.opco?.defaultAppointmentTypeIdPDP

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const { productType } = props.product
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const specificationConfiguration = getSpecifications(productType) || []
  const pdpRoute: RouteConfigs | undefined = defaultAppointmentTypeId
    ? {
        route: 'appointments.book',
        query: new URLSearchParams({ typeId: defaultAppointmentTypeId }),
      }
    : undefined

  return (
    <Page
      {...props}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      specificationConfiguration={specificationConfiguration}
      bookAppointmentRouteConfig={pdpRoute}
    />
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps
export default composePDP<Props>(ProductDetailPage)
